import React, { Component } from 'react'
import { withStyles, Button } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete'

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'scroll'
    }
})

class Journals extends Component {
    state = {
        title: '',
        journal: '',
        issn: '',
        impact_factor:'',
        no_co_au:'',
        main_au:'',
        api_score:'',
        total:'',
        year:'',
        journals: []
    }

    componentDidMount(){
        //console.log(this.props)
        this.setState({
            journals:this.props.journals,
            total:this.props.total
        })
    }

    componentDidUpdate(prevProps){
        if(this.props !== prevProps){
            this.setState({
                journals:this.props.journals,
                total:this.props.total

            })
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onSubmit = () => {
        let d = {
            title: this.state.title,
            journal: this.state.journal,
            issn: this.state.issn,
            impact_factor: this.state.impact_factor,
            no_co_au: this.state.no_co_au,
            main_au: this.state.main_au,
            api_score: this.state.api_score,
            year: this.state.year,
            
        }

        let journals = this.state.journals;
        journals.push(d);
        this.setState({
            journals
        }, () => {
                this.props.setJournals(journals);
                this.setState({
                    title: '',
                    journal: '',
                    issn: '',
                    impact_factor:'',
                    no_co_au:'',
                    main_au:'',
                    api_score:'',
                    year:'',
                })
        })
    }

    onDelete = (index) => {
        let journals = this.state.journals;
        journals.splice(index,1);
        this.props.setJournals(journals);
        this.setState({
            journals
        })
    }
    render() {
        let { classes } = this.props;
        return (
            <div className={classes.root}>
                <table width="100%" className="table">

                    <thead>
                        <tr>
                            <td width="30%">Title with Page Numbers</td>
                            <td width="20%">Journal</td>
                           
                            <td>ISSN/ ISBN No.</td>
                            <td>Whether Peer Reviewed Impact Factor, if any </td>
                            <td>No. of 
                                    Co-author</td>
                                    <td>Whether you are the main author</td>
                                    <td>API Score</td>
                                    <td>Year</td>
                            <td>Click + to Add</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width="30%">
                                <textarea
                                    className="form-control"
                                    type="text"
                                    name="title"
                                    value={this.state.title}
                                    onChange={this.onChange}
                                    placeholder="Title with Page Numbers"
                                />
                            </td>
                            <td width="20%">
                                <textarea
                                    className="form-control"
                                    type="text"
                                    name="journal"
                                    value={this.state.journal}
                                    onChange={this.onChange}
                                    placeholder="Journal"
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="issn"
                                    value={this.state.issn}
                                    onChange={this.onChange}
                                    placeholder="ISSN/ ISBN No"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="impact_factor"
                                    value={this.state.impact_factor}
                                    onChange={this.onChange}
                                    placeholder="Whether Peer Reviewed Impact Factor, if any"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="no_co_au"
                                    value={this.state.no_co_au}
                                    onChange={this.onChange}
                                    placeholder="No. of 
                                    Co-author"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="main_au"
                                    value={this.state.main_au}
                                    onChange={this.onChange}
                                    placeholder="Whether you are the main author"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="api_score"
                                    value={this.state.api_score}
                                    onChange={this.onChange}
                                    placeholder="API Score"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="year"
                                    value={this.state.year}
                                    onChange={this.onChange}
                                    placeholder="Year"
                                />
                            </td>
                            
                           
                            <td>

                                <Button
                                    variant="outlined"
                                    onClick={this.onSubmit}
                                    type="button"
                                >
                                    +
                                </Button>

                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        {this.state.journals.map((el, index) =>

                            <tr key={index}>
                                <td>{index+1}. {el.title}</td>
                                <td>{el.journal}</td>
                                <td>{el.issn}</td>
                                <td>{el.impact_factor}</td>
                                <td>{el.no_co_au}</td>
                                <td>{el.main_au}</td>
                                <td>{el.api_score}</td>
                                <td>{el.year}</td>
                                
                                <td><Delete onClick={this.onDelete.bind(this,index)} /></td>
                            </tr>

                        )}
                        <tr><td colSpan={9}>&nbsp;</td></tr>
                        {this.state.journals.length>0 && <tr>
                            <td colSpan={6} align="right">Total</td>
                            <td colSpan={3} align="left">{this.state.total}</td>
                            </tr>}
                    </tbody>

                </table>
            </div>
        )
    }
}

export default withStyles(styles)(Journals)